import React from 'react';
import { Label } from './Label';
import { InlineError } from './InlineError';
import { HelpText } from './HelpText';

export type FieldProps = {
  label?: React.ReactNode;
  labelFor?: string;
  required?: boolean;
  helpText?: React.ReactNode;
  error?: React.ReactNode;
  children: React.ReactNode;
  inline?: boolean;
  className?: string;
};

export function Field({
  label,
  labelFor,
  required,
  helpText,
  error,
  children,
  inline = false,
  className
}: FieldProps) {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: inline ? 'row' : 'column',
        gap: '0.5rem'
      }}
    >
      {label && (
        <Label htmlFor={labelFor} required={required}>
          {label}
        </Label>
      )}
      {children}
      {helpText && <HelpText>{helpText}</HelpText>}
      {error && <InlineError>{error}</InlineError>}
    </div>
  );
}
